const dev_packages = [
  { name: "Enterprise", product_id: "prod_RFMaWFChUnFMzb" },
  { name: "Startup", product_id: "prod_RFMZzeSq2IPqkv" },
  { name: "Business", product_id: "prod_RFMaugTCe9iSmH" },
  { name: "Lifetime", product_id: "lifetime_product" },
  { name: "Trial", product_id: "trial_product" },
];

const live_packages = [
  { name: "Startup", product_id: "prod_Sj7KQxbLvpcUfc" },
  { name: "Lifetime Internal", product_id: "lifetime_product" },
  { name: "Business", product_id: "prod_Sj7LwEjoy1rCQE" },
  { name: "Lifetime Package", product_id: "prod_Sj7MX4LgOC5OXy" },
];

export function getNameByProductId(product_id) {
  const pkg = live_packages.find((pkg) => pkg.product_id === product_id); // live packages
  // const pkg = dev_packages.find((pkg) => pkg.product_id === product_id); // dev packages
  return pkg ? pkg.name : null;
}
